import {
    ACCOUNT_LIST_PAGE_LOADED,
    ACCOUNT_LIST_PAGE_UNLOADED,
    ACCOUNT_DETAIL_PAGE_LOADED,
    ACCOUNT_DETAIL_NEXT_PAGE_LOADED,
    ACCOUNT_DETAIL_PAGE_UNLOADED,
    TRANSACTION_DETAIL_PAGE_LOADED,
    TRANSACTION_DETAIL_PAGE_UNLOADED,
    SEND_LOADED,
    SEND_UNLOADED,
    SEND_FUNDS,
    DEPOSIT_ETH_LOADED,
    DEPOSIT_ETH_UNLOADED,
    DEPOSIT_BTC_LOADED,
    DEPOSIT_BTC_UNLOADED,
    WITHDRAW_ETH_LOADED,
    WITHDRAW_ETH,
    WITHDRAW_ETH_UNLOADED,
    WITHDRAW_BTC_LOADED,
    WITHDRAW_BTC,
    WITHDRAW_BTC_UNLOADED,
    WITHDRAW_GET_TRANS_FEE
} from '../constants/actionTypes'
import { REACT_APP_PAGESIZE } from '../constants/config'

export default (state = {}, action) => {
    switch (action.type) {
        case ACCOUNT_LIST_PAGE_LOADED:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                accounts: action.error ? [] : action.payload.accounts,
            };
        case ACCOUNT_DETAIL_PAGE_LOADED:
        case ACCOUNT_DETAIL_NEXT_PAGE_LOADED:
            return {
                ...state,
                account: action.payload.account,
                transactions: action.payload.account.transactions,
                totalCount: action.payload.account.totalCount,
                currentPage: action.currentPage,
                totalPage: Math.ceil(action.payload.account.totalCount / REACT_APP_PAGESIZE)
            };
        case TRANSACTION_DETAIL_PAGE_LOADED:
            return {
                ...state,
                transaction: action.error ? null : action.payload[0].transaction,
                transactions: action.error ? [] : action.payload[1].account.transactions,
            }
        case SEND_LOADED:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                prime_accounts: action.error ? null : action.payload[0].accounts,
                fees: action.error ? null : action.payload[1].fees,
            }
        case SEND_FUNDS:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                amount: action.error ? null : action.payload ? action.payload.amount : null,
                codeStatus: action.error ? null : action.payload ? action.payload.code_status : null,
            }
        case DEPOSIT_ETH_LOADED:
        case DEPOSIT_BTC_LOADED:
        case WITHDRAW_ETH_LOADED:
        case WITHDRAW_BTC_LOADED:
            return {
                ...state,
                account: action.payload ? action.payload.account : null,
            }
        case WITHDRAW_ETH:
        case WITHDRAW_BTC:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                success: action.payload.transaction_hash ? true : false,
                codeStatus: action.error ? null : action.payload ? action.payload.code_status : null,
            }
        case WITHDRAW_GET_TRANS_FEE:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                fee: action.error ? 0 : action.payload.fee
            }
        case ACCOUNT_LIST_PAGE_UNLOADED:
        case ACCOUNT_DETAIL_PAGE_UNLOADED:
        case TRANSACTION_DETAIL_PAGE_UNLOADED:
        case SEND_UNLOADED:
        case DEPOSIT_ETH_UNLOADED:
        case DEPOSIT_BTC_UNLOADED:
        case WITHDRAW_ETH_UNLOADED:
        case WITHDRAW_BTC_UNLOADED:
            return {};
        default:
            return state
    }
};
